import { render, staticRenderFns } from "./WorkerDashboard2.vue?vue&type=template&id=ee544018&scoped=true&"
import script from "./WorkerDashboard2.vue?vue&type=script&lang=js&"
export * from "./WorkerDashboard2.vue?vue&type=script&lang=js&"
import style0 from "./WorkerDashboard2.vue?vue&type=style&index=0&id=ee544018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee544018",
  null
  
)

export default component.exports